export const environment = process.env.NEXT_PUBLIC_PROJECT_ENV || "";
export const tenant = process.env.NEXT_PUBLIC_TENANT || "";
export const sentryEnvironment = process.env.NEXT_PUBLIC_SENTRY_ENV || "";
export const isProductionReady = ["staging", "production", "uat"].includes(
  environment
);
export const isLocalEnv = !isProductionReady && !process.env.CI;

export const decovoShopAppId = "ce256574-90a0-443b-b7a9-c68ea4dc178f";
export const sentryDSN = process.env.NEXT_PUBLIC_SENTRY_DSN || "";

export const imgWidths = [345, 600, 690];

export const shipping = {
  us: {
    free: 0,
    below: "0",
    threshold: 1000000000000000000000000,
  },
};

export const cart = {
  discounts: {
    hideDiscountsMaxThreshold: 2,
    showSavingsMaxThreshold: 10,
  },
  maxCartQty: 9999,
};

export const cookies = {
  localStorageUserKey: "caps_user",
  cartCookieName: "decovo-shoppingcart",
  secureCookie: isProductionReady,
};

export const endpoints = {
  cdn: process.env.NEXT_PUBLIC_CDN_URL || "",
  productsImgCdn: process.env.NEXT_PUBLIC_IMG_CDN_ROOT || "",
  web: process.env.NEXT_PUBLIC_WEB_ROOT || "",
  api: process.env.NEXT_PUBLIC_API_ROOT || "",
  cart: process.env.NEXT_PUBLIC_CART_ROOT || "",
  checkout: process.env.NEXT_PUBLIC_CHECKOUT_ROOT || "",
  portalService: process.env.NEXT_PUBLIC_PORTAL_SERVICE_ROOT || "",
  portalFrontend: process.env.NEXT_PUBLIC_PORTAL_FRONTEND_ROOT || "",
  corporateFrontend: process.env.NEXT_PUBLIC_CORPORATE_FRONTEND_ROOT || "",
  graphqlBackend: process.env.NEXT_PUBLIC_GRAPHQL_ROOT || "",
  internalApi: process.env.NEXT_INTERNAL_API_ROOT || "",
  datoCmsEndpoint: process.env.NEXT_PUBLIC_DATOCMS_ENDPOINT || "",
};

export const headerPromotion = {
  shouldShow: false,
  promotionText: "Free Shipping Over $20",
};

export const links = {
  support: "support@pepsicoshop.co",
};
